import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemApiService } from '@cv-invision/core';

@Injectable({
	providedIn: 'root'
})
export class NexsysOrderMessageService {
	private readonly BASE_URL = '/utils';
	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) { }

	/**
	 * GET - Return the list of the Nexsys orders messages configuration mappings.
	 */
	getNexsysOrderMessageStatus(origin: string): Observable<any> {
		return this.httpClient.get(
			`${this.systemApiService.api.orders}${this.BASE_URL}/nexsys/mapper/custom-outgoing-messages-status?origin=${origin}`
		);
	}
}
